import { api } from '../config/api';

export const certificationService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.type) params.append('type', filters.type);
    if (filters.expiring_soon) params.append('expiring_soon', 'true');
    
    const queryString = params.toString();
    return api.get(`/api/certifications${queryString ? `?${queryString}` : ''}`);
  },
  
  getById: async (id) => {
    return api.get(`/api/certifications/${id}`);
  },
  
  getByEmployee: async (userId) => {
    return api.get(`/api/certifications/employee/${userId}`);
  },
  
  getTypes: async () => {
    return api.get('/api/certifications/types');
  },
  
  create: async (data) => {
    return api.post('/api/certifications', data);
  },
  
  update: async (id, data) => {
    return api.put(`/api/certifications/${id}`, data);
  },
  
  renew: async (id, data) => {
    return api.post(`/api/certifications/${id}/renew`, data);
  },
  
  delete: async (id) => {
    return api.delete(`/api/certifications/${id}`);
  },
  
  getExpiring: async (days = 30) => {
    return api.get(`/api/certifications/expiring?days=${days}`);
  }
};
